// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Policy Pages Common Styling */
.policy-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 1rem;
  font-family: "Montserrat", sans-serif;
  color: #333;
  line-height: 1.6;
}

.policy-header {
  text-align: center;
  margin-bottom: 3rem;
  padding-bottom: 2rem;
  border-bottom: 2px solid #f0f0f0;
}

.policy-header h1 {
  font-size: 2.5rem;
  color: #2c3e50;
  margin-bottom: 0.5rem;
  font-weight: 700;
}

.policy-subtitle {
  font-size: 1.2rem;
  color: #7f8c8d;
  font-style: italic;
}

.policy-date {
  color: #95a5a6;
  font-size: 0.9rem;
  margin-top: 0.5rem;
}

.policy-content {
  background: #fff;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
}

.policy-section {
  margin-bottom: 2.5rem;
}

.policy-section:last-child {
  margin-bottom: 0;
}

.policy-section h2 {
  color: #2c3e50;
  font-size: 1.8rem;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #6a11cb;
  font-weight: 600;
}

.policy-section h3 {
  color: #34495e;
  font-size: 1.3rem;
  margin: 1.5rem 0 0.75rem;
  font-weight: 600;
}

.policy-section p {
  margin-bottom: 1rem;
  font-size: 1.05rem;
}

.policy-section ul {
  margin: 1rem 0;
  padding-left: 1.5rem;
}

.policy-section ul li {
  margin-bottom: 0.5rem;
  font-size: 1.05rem;
}

.policy-section ul li strong {
  color: #2c3e50;
}

/* Services Grid for About Page */
.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin: 2rem 0;
}

.service-card {
  background: #f8f9fa;
  padding: 1.5rem;
  border-radius: 8px;
  border-left: 4px solid #6a11cb;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.service-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.service-card h3 {
  color: #2c3e50;
  margin-bottom: 1rem;
  font-size: 1.3rem;
}

/* Mission List */
.mission-list {
  list-style: none;
  padding: 0;
}

.mission-list li {
  background: #f8f9fa;
  padding: 1rem;
  margin-bottom: 0.75rem;
  border-radius: 5px;
  border-left: 3px solid #2575fc;
}

/* Delivery Timelines */
.delivery-timelines {
  display: grid;
  gap: 1.5rem;
  margin: 1.5rem 0;
}

.timeline-item {
  background: #f8f9fa;
  padding: 1.25rem;
  border-radius: 8px;
  border-top: 3px solid #27ae60;
}

.timeline-item h3 {
  color: #2c3e50;
  margin-bottom: 0.5rem;
  font-size: 1.2rem;
}

/* Contact Section */
.contact-section {
  background: linear-gradient(135deg, #f8f9fa, #e9ecef);
  padding: 2rem;
  border-radius: 10px;
  margin-top: 3rem;
}

.contact-info {
  background: white;
  padding: 1.5rem;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.contact-info p {
  margin-bottom: 0.75rem;
  font-size: 1.05rem;
}

.contact-info strong {
  color: #2c3e50;
  min-width: 80px;
  display: inline-block;
}

/* Responsive Design */
@media (max-width: 768px) {
  .policy-page {
    padding: 1rem;
  }

  .policy-header h1 {
    font-size: 2rem;
  }

  .policy-content {
    padding: 1.5rem;
  }

  .policy-section h2 {
    font-size: 1.5rem;
  }

  .services-grid {
    grid-template-columns: 1fr;
  }

  .contact-info p {
    font-size: 0.95rem;
  }
}

@media (max-width: 480px) {
  .policy-header h1 {
    font-size: 1.8rem;
  }

  .policy-content {
    padding: 1rem;
  }

  .policy-section {
    margin-bottom: 2rem;
  }

  .contact-section {
    padding: 1.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/PolicyPages.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,qCAAqC;EACrC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,8BAA8B;EAC9B,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,qDAAqD;EACrD,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Policy Pages Common Styling */\n.policy-page {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 2rem 1rem;\n  font-family: \"Montserrat\", sans-serif;\n  color: #333;\n  line-height: 1.6;\n}\n\n.policy-header {\n  text-align: center;\n  margin-bottom: 3rem;\n  padding-bottom: 2rem;\n  border-bottom: 2px solid #f0f0f0;\n}\n\n.policy-header h1 {\n  font-size: 2.5rem;\n  color: #2c3e50;\n  margin-bottom: 0.5rem;\n  font-weight: 700;\n}\n\n.policy-subtitle {\n  font-size: 1.2rem;\n  color: #7f8c8d;\n  font-style: italic;\n}\n\n.policy-date {\n  color: #95a5a6;\n  font-size: 0.9rem;\n  margin-top: 0.5rem;\n}\n\n.policy-content {\n  background: #fff;\n  padding: 2rem;\n  border-radius: 10px;\n  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);\n}\n\n.policy-section {\n  margin-bottom: 2.5rem;\n}\n\n.policy-section:last-child {\n  margin-bottom: 0;\n}\n\n.policy-section h2 {\n  color: #2c3e50;\n  font-size: 1.8rem;\n  margin-bottom: 1rem;\n  padding-bottom: 0.5rem;\n  border-bottom: 2px solid #6a11cb;\n  font-weight: 600;\n}\n\n.policy-section h3 {\n  color: #34495e;\n  font-size: 1.3rem;\n  margin: 1.5rem 0 0.75rem;\n  font-weight: 600;\n}\n\n.policy-section p {\n  margin-bottom: 1rem;\n  font-size: 1.05rem;\n}\n\n.policy-section ul {\n  margin: 1rem 0;\n  padding-left: 1.5rem;\n}\n\n.policy-section ul li {\n  margin-bottom: 0.5rem;\n  font-size: 1.05rem;\n}\n\n.policy-section ul li strong {\n  color: #2c3e50;\n}\n\n/* Services Grid for About Page */\n.services-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 2rem;\n  margin: 2rem 0;\n}\n\n.service-card {\n  background: #f8f9fa;\n  padding: 1.5rem;\n  border-radius: 8px;\n  border-left: 4px solid #6a11cb;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.service-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);\n}\n\n.service-card h3 {\n  color: #2c3e50;\n  margin-bottom: 1rem;\n  font-size: 1.3rem;\n}\n\n/* Mission List */\n.mission-list {\n  list-style: none;\n  padding: 0;\n}\n\n.mission-list li {\n  background: #f8f9fa;\n  padding: 1rem;\n  margin-bottom: 0.75rem;\n  border-radius: 5px;\n  border-left: 3px solid #2575fc;\n}\n\n/* Delivery Timelines */\n.delivery-timelines {\n  display: grid;\n  gap: 1.5rem;\n  margin: 1.5rem 0;\n}\n\n.timeline-item {\n  background: #f8f9fa;\n  padding: 1.25rem;\n  border-radius: 8px;\n  border-top: 3px solid #27ae60;\n}\n\n.timeline-item h3 {\n  color: #2c3e50;\n  margin-bottom: 0.5rem;\n  font-size: 1.2rem;\n}\n\n/* Contact Section */\n.contact-section {\n  background: linear-gradient(135deg, #f8f9fa, #e9ecef);\n  padding: 2rem;\n  border-radius: 10px;\n  margin-top: 3rem;\n}\n\n.contact-info {\n  background: white;\n  padding: 1.5rem;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n}\n\n.contact-info p {\n  margin-bottom: 0.75rem;\n  font-size: 1.05rem;\n}\n\n.contact-info strong {\n  color: #2c3e50;\n  min-width: 80px;\n  display: inline-block;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .policy-page {\n    padding: 1rem;\n  }\n\n  .policy-header h1 {\n    font-size: 2rem;\n  }\n\n  .policy-content {\n    padding: 1.5rem;\n  }\n\n  .policy-section h2 {\n    font-size: 1.5rem;\n  }\n\n  .services-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .contact-info p {\n    font-size: 0.95rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .policy-header h1 {\n    font-size: 1.8rem;\n  }\n\n  .policy-content {\n    padding: 1rem;\n  }\n\n  .policy-section {\n    margin-bottom: 2rem;\n  }\n\n  .contact-section {\n    padding: 1.5rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
